import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { OpenXAgentArrowCircleRightIcon } from '../icons/OpenXAgentArrowCircleRightIcon.tsx';
import { OpenXAgentChatBubbleIcon } from '../icons/OpenXAgentChatBubbleIcon.tsx';
import { buttonSx, iconSx, iconWrapperSx, labelSx } from './ActionButton.styles.ts';

export type ActionButtonProps = {
  label: string;
  isConfirmed?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const withSentenceEnding = (label: string) => (/[.!?]$/.test(label) ? label : `${label}.`);

export const ActionButton = ({ label, isConfirmed = false, disabled = false, onClick }: ActionButtonProps) => {
  const renderedLabel = isConfirmed ? withSentenceEnding(label) : label;

  return (
    <ButtonBase
      data-test="action-button"
      data-state={isConfirmed ? 'confirmed' : 'pending'}
      aria-pressed={isConfirmed}
      disabled={disabled}
      onClick={onClick}
      sx={buttonSx}
    >
      <Box aria-hidden sx={iconWrapperSx}>
        {isConfirmed ? (
          <OpenXAgentChatBubbleIcon data-test="action-button-confirmed-icon" sx={iconSx} />
        ) : (
          <OpenXAgentArrowCircleRightIcon data-test="action-button-pending-icon" sx={iconSx} />
        )}
      </Box>

      <Typography component="span" sx={labelSx}>
        {renderedLabel}
      </Typography>
    </ButtonBase>
  );
};
